import { render, staticRenderFns } from "./PortDetails.vue?vue&type=template&id=a0543fb8&scoped=true&"
import script from "./PortDetails.vue?vue&type=script&lang=js&"
export * from "./PortDetails.vue?vue&type=script&lang=js&"
import style0 from "./PortDetails.vue?vue&type=style&index=0&id=a0543fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0543fb8",
  null
  
)

export default component.exports